// The server normalizes entries further; this only splits the pasted list and strips dashes.
export function parseKennitalas(text: string): string[] {
	return text
		.split(/[\s,;]+/)
		.map(entry => entry.replaceAll('-', ''))
		.filter(Boolean);
}
